<script setup lang="ts">
import { ref } from 'vue'
import { usePermissionsStore } from '@/stores/permissions'
import { useCurrentOpRole } from '@/composables/useCurrentOpRole'
import { useRoute } from 'vue-router'
import CheckInStats from '@/components/personnel/CheckInStats.vue'
import PersonnelTable from '@/components/personnel/PersonnelTable.vue'
import CheckInModal from '@/components/personnel/CheckInModal.vue'
import FosButton from '@/components/ui/FosButton.vue'
import FosInput from '@/components/ui/FosInput.vue'

const route = useRoute()
const incidentId = route.params.id as string

const permissionsStore = usePermissionsStore()
const { opRole } = useCurrentOpRole()

const searchQuery = ref('')
const showCheckIn = ref(false)

const canCheckIn = () => permissionsStore.can('personnel.checkin', opRole.value)
</script>

<template>
  <div class="h-full flex flex-col overflow-hidden">
    <!-- Header -->
    <div class="flex items-center gap-3 px-4 py-3 border-b border-border shrink-0">
      <RouterLink
        :to="{ name: 'incident-settings', params: { id: incidentId } }"
        class="text-[10px] text-outline font-label uppercase tracking-widest hover:text-on-surface-variant transition-colors flex items-center gap-1 shrink-0"
      >
        <span class="material-symbols-outlined text-[14px]">arrow_back</span>
        Settings
      </RouterLink>
      <CheckInStats />
      <div class="flex-1" />
      <FosInput
        v-model="searchQuery"
        placeholder="Search by name or agency…"
        class="w-56"
      />
      <FosButton
        v-if="canCheckIn()"
        variant="primary"
        @click="showCheckIn = true"
      >
        <span class="material-symbols-outlined text-[16px]">person_add</span>
        Check In
      </FosButton>
    </div>

    <!-- Table -->
    <div class="flex-1 overflow-auto">
      <PersonnelTable :search-query="searchQuery" />
    </div>
  </div>

  <CheckInModal
    v-model:visible="showCheckIn"
    :incident-id="incidentId"
  />
</template>
